import { render, staticRenderFns } from "./WeightEdit.vue?vue&type=template&id=7e060609&lang=pug"
import script from "./WeightEdit.vue?vue&type=script&lang=js"
export * from "./WeightEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports